import styled, { css } from 'styled-components';

import { ChevronIcon, OrganizationIcon } from '~/assets';
import { SquareImageComponent } from '~/components';
import { ThemeProp } from '~/theme/Themes';

export const Container = styled.div`
  display: flex;
  margin-top: 1.25rem;
`;

interface TriggerContainerProps {
  $collapsed?: boolean;
}

export const TriggerContainer = styled.button<TriggerContainerProps>`
  display: flex;
  align-items: center;
  justify-content: ${(props: TriggerContainerProps) => (props.$collapsed ? 'center' : 'flex-start')};
  gap: 0.5rem;
  padding: ${(props: TriggerContainerProps) => (props.$collapsed ? '0' : '0 0.5rem')};
  height: 2.25rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
  width: ${(props: TriggerContainerProps) => (props.$collapsed ? '2.25rem' : '100%')};
  background: transparent;
  cursor: pointer;
`;

export const initialsAvatarStyles = css`
  border-radius: 4.5px;

  .nextui-avatar-bg {
    background: ${(props: ThemeProp) => props.theme.colors.primary.c500};
    opacity: 0.1;
  }

  .nextui-avatar-text {
    font-size: 1rem;
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
    line-height: 1;
    color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
  }
`;

export const TriggerAvatar = styled(SquareImageComponent)`
  ${initialsAvatarStyles}
`;

export const DropDownItemAvatar = styled(SquareImageComponent)`
  ${initialsAvatarStyles}
`;

export const AllOrgsAvatar = styled(OrganizationIcon)`
  width: 1.5rem;
  height: 1.5rem;
  padding: 2px;
  border-radius: 4.5px;
  flex-shrink: 0;
  background: ${(props: ThemeProp) => props.theme.colors.primaryLight};

  path {
    stroke: ${(props: ThemeProp) => props.theme.colors.primary.c500};
  }
`;

export const TriggerName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;

export const TriggerChevron = styled(ChevronIcon)`
  width: 0.625rem;
  height: auto;
  margin-left: auto;
  flex-shrink: 0;
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;
